import * as Yup from 'yup';

export const ExerciseSchema = Yup.object().shape({
  name: Yup.string().required('Nome necessário.'),
  muscle_segment: Yup.string().required('Segmento necessário.'),
});
